//此处一定要和css的前缀保持一致
const PRE = 'pop';
export {
	PRE
};
// 判断参数是否是其中之一
export function oneOf(value, validList) {
	for(let i = 0; i < validList.length; i++) {
		if(value === validList[i]) {
			return true;
		}
	}
	return false;
}

export function camelcaseToHyphen(str) {
	return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

// For Modal scrollBar hidden
let cached;
export function getScrollBarSize(fresh) {
	if(fresh || cached === undefined) {
		const inner = document.createElement('div');
		inner.style.width = '100%';
		inner.style.height = '200px';

		const outer = document.createElement('div');
		const outerStyle = outer.style;

		outerStyle.position = 'absolute';
		outerStyle.top = 0;
		outerStyle.left = 0;
		outerStyle.pointerEvents = 'none';
		outerStyle.visibility = 'hidden';
		outerStyle.width = '200px';
		outerStyle.height = '150px';
		outerStyle.overflow = 'hidden';

		outer.appendChild(inner);

		document.body.appendChild(outer);

		const widthContained = inner.offsetWidth;
		outer.style.overflow = 'scroll';
		let widthScroll = inner.offsetWidth;

		if(widthContained === widthScroll) {
			widthScroll = outer.clientWidth;
		}

		document.body.removeChild(outer);

		cached = widthContained - widthScroll;
	}
	return cached;
}
// export function browserType() {
// 	var userAgent = navigator.userAgent; 
// 	var isOpera = userAgent.indexOf("Opera") > -1; 
// 	var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera;
// 	var isEdge = userAgent.indexOf("Windows NT 6.1; Trident/7.0;") > -1 && !isIE;
// 	var isFF = userAgent.indexOf("Firefox") > -1;
// 	var isSafari = userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1; 
// 	var isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1; 
// 	if(isIE) {
// 		var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
// 		reIE.test(userAgent);
// 		var fIEVersion = parseFloat(RegExp["$1"]);
// 		if(fIEVersion == 7) {
// 			return "IE7";
// 		} else if(fIEVersion == 8) {
// 			return "IE8";
// 		} else if(fIEVersion == 9) {
// 			return "IE9";
// 		} else if(fIEVersion == 10) {
// 			return "IE10";
// 		} else if(fIEVersion == 11) {
// 			return "IE11";
// 		} else {
// 			return "0"
// 		} 
// 	}

// 	if(isFF) {
// 		return "FF";
// 	}
// 	if(isOpera) {
// 		return "Opera";
// 	}
// 	if(isSafari) {
// 		return "Safari";
// 	}
// 	if(isChrome) {
// 		return "Chrome";
// 	}
// 	if(isEdge) {
// 		return "Edge";
// 	}
// }

// watch DOM change
// export const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver || false;

const SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
const MOZ_HACK_REGEXP = /^moz([A-Z])/;

function camelCase(name) {
	return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
		return offset ? letter.toUpperCase() : letter;
	}).replace(MOZ_HACK_REGEXP, 'Moz$1');
}
// getStyle
export function getStyle(element, styleName) {
	if(!element || !styleName) return null;
	styleName = camelCase(styleName);
	if(styleName === 'float') {
		styleName = 'cssFloat';
	}
	try {
		const computed = document.defaultView.getComputedStyle(element, '');
		return element.style[styleName] || computed ? computed[styleName] : null;
	} catch(e) {
		return element.style[styleName];
	}
}

// firstUpperCase
function firstUpperCase(str) {
	return str.toString()[0].toUpperCase() + str.toString().slice(1);
}
export {
	firstUpperCase
};

// Warn
// export function warnProp(component, prop, correctType, wrongType) {
// 	correctType = firstUpperCase(correctType);
// 	wrongType = firstUpperCase(wrongType);
// 	console.error(`[Pop Design warn]: Invalid prop: type check failed for prop ${prop}. Expected ${correctType}, got ${wrongType}. (found in component: ${component})`);
// }

export function typeOf(obj) {
	const toString = Object.prototype.toString;
	const map = {
		'[object Boolean]': 'boolean',
		'[object Number]': 'number',
		'[object String]': 'string',
		'[object Function]': 'function',
		'[object Array]': 'array',
		'[object Date]': 'date',
		'[object RegExp]': 'regExp',
		'[object Undefined]': 'undefined',
		'[object Null]': 'null',
		'[object Object]': 'object'
	};
	return map[toString.call(obj)];
}

// deepCopy
function deepCopy(data) {
	const t = typeOf(data);
	let o;

	if(t === 'array') {
		o = [];
	} else if(t === 'object') {
		o = {};
	} else {
		return data;
	}

	if(t === 'array') {
		for(let i = 0; i < data.length; i++) {
			o.push(deepCopy(data[i]));
		}
	} else if(t === 'object') {
		for(let i in data) {
			o[i] = deepCopy(data[i]);
		}
	}
	return o;
}

export {
	deepCopy
};

// scrollTop animation
export function scrollTop(el, from = 0, to, duration = 500) {
	if(!window.requestAnimationFrame) {
		window.requestAnimationFrame = (
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			}
		);
	}
	const difference = Math.abs(from - to);
	const step = Math.ceil(difference / duration * 50);

	function scroll(start, end, step) {
		if(start === end) return;

		let d = (start + step > end) ? end : start + step;
		if(start > end) {
			d = (start - step < end) ? end : start - step;
		}

		if(el === window) {
			window.scrollTo(d, d);
		} else {
			el.scrollTop = d;
		}
		window.requestAnimationFrame(() => scroll(d, end, step));
	}
	scroll(from, to, step);
}
//function dateFormat(date,format) {
//  var args = {
//      "M+": date.getMonth() + 1,
//      "d+": date.getDate(),
//      "h+": date.getHours(),
//      "m+": date.getMinutes(),
//      "s+": date.getSeconds(),
//      "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
//      "S": date.getMilliseconds()
//  };
//  if(/(y+)/.test(format))
//      format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
//  for(var i in args) {
//      var n = args[i];
//      if(new RegExp("(" + i + ")").test(format))
//          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? n : ("00" + n).substr(("" + n).length));
//  }
//  return format;
//};
//function dateReduce(end,begin) {
//  var time = ((end.getTime() - begin.getTime()) / (60 * 60 * 1000)).toFixed(4);
//  time = time.toString();
//  var hour = time.substr(0, time.indexOf("."));
//  var minute = (time.substr(time.indexOf("."), time.length) * 60).toFixed(0);
//  return [hour, minute];
//};
//function dateModify(date, days, operator) {
//  var nd = new Date(date);
//  nd = nd.valueOf();
//  if(operator == "+") {
//      nd = nd + days * 24 * 60 * 60 * 1000;
//  } else if(operator == "-") {
//      nd = nd - days * 24 * 60 * 60 * 1000;
//  } else {
//      return false;
//  }
//  nd = new Date(nd);
//  return nd;
//}


// Find components upward
function findComponentUpward (context, componentName, componentNames) {
    if (typeof componentName === 'string') {
        componentNames = [componentName];
    } else {
        componentNames = componentName;
    }

    let parent = context.$parent;
    let name = parent.$options.name;
    while (parent && (!name || componentNames.indexOf(name) < 0)) {
        parent = parent.$parent;
        if (parent) name = parent.$options.name;
    }
    return parent;
}
export {findComponentUpward};

// Find component downward
function findComponentDownward (context, componentName) {
    const childrens = context.$children;
    let children = null;
    if (childrens&&childrens.length) {
        childrens.forEach(child => {
            const name = child.$options.name;
            if (name === componentName) {
                children = child;
            }
        });

        for (let i = 0; i < childrens.length; i++) {
            const child = childrens[i];
            const name = child.$options.name;
            if (name === componentName) {
                children = child;
                break;
            } else {
                children = findComponentDownward(child, componentName);
                if (children) break;
            }
        }
    }
    return children;
}
export {findComponentDownward};

// Find components downward
// function findComponentsDownward (context, componentName, components = []) {
//     const childrens = context.$children;

//     if (childrens.length) {
//         childrens.forEach(child => {
//             const name = child.$options.name;
//             const childs = child.$children;

//             if (name === componentName) components.push(child);
//             if (childs.length) {
//                 const findChilds = findComponentsDownward(child, componentName, components);
//                 if (findChilds) components.concat(findChilds);
//             }
//         });
//     }
//     return components;
// }
// export {findComponentsDownward};

/* istanbul ignore next */
// const trim = function(string) {
//     return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
// };

/* istanbul ignore next */
// export function hasClass(el, cls) {
//     if (!el || !cls) return false;
//     if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
//     if (el.classList) {
//         return el.classList.contains(cls);
//     } else {
//         return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
//     }
// }

/* istanbul ignore next */
// export function addClass(el, cls) {
//     if (!el) return;
//     let curClass = el.className;
//     const classes = (cls || '').split(' ');

//     for (let i = 0, j = classes.length; i < j; i++) {
//         const clsName = classes[i];
//         if (!clsName) continue;

//         if (el.classList) {
//             el.classList.add(clsName);
//         } else {
//             if (!hasClass(el, clsName)) {
//                 curClass += ' ' + clsName;
//             }
//         }
//     }
//     if (!el.classList) {
//         el.className = curClass;
//     }
// }

/* istanbul ignore next */
// export function removeClass(el, cls) {
//     if (!el || !cls) return;
//     const classes = cls.split(' ');
//     let curClass = ' ' + el.className + ' ';

//     for (let i = 0, j = classes.length; i < j; i++) {
//         const clsName = classes[i];
//         if (!clsName) continue;

//         if (el.classList) {
//             el.classList.remove(clsName);
//         } else {
//             if (hasClass(el, clsName)) {
//                 curClass = curClass.replace(' ' + clsName + ' ', ' ');
//             }
//         }
//     }
//     if (!el.classList) {
//         el.className = trim(curClass);
//     }
// }


function getUrlParam(url) {
	url = url || window.location.href;
	var objRequest = new Object();
	if(url.indexOf("?") != -1) {
		url = url.split("?")[1];
		var strArr = url.split("&");
		for(var i = 0; i < strArr.length; i++) {
			objRequest[strArr[i].split("=")[0]] = decodeURI((strArr[i].split("=")[1]));
		}
	}
	return objRequest;
}

function getJsonObjLength(jsonObj) {
	var Length = 0;
	for(var item in jsonObj) {
		Length++;
	}
	return Length;
}

function clearObj(obj) {
	var returnObj = {};
	for(var i in obj) {
		obj[i] ? returnObj[i] = obj[i] : null;
	}
	return returnObj;
}

function isGoRouter($query) {
	var href = location.href;
	var hash = location.hash;
	var queryClone = deepCopy($query);
	var query = clearObj(queryClone);
	var urlQuery = clearObj(getUrlParam(href.substr(href.indexOf('#') + 2)));
	var goRouter = false;
	for(var i in getJsonObjLength(urlQuery) > getJsonObjLength(query) ? urlQuery : query) {
		if(decodeURIComponent(urlQuery[i]) != query[i]) {
			goRouter = true;
			break;
		}
	}
	return goRouter;
}

function getRouterPath() {
	var hash = location.hash;
	return hash.substr(2, hash.indexOf('?') == -1 ? hash.length - 1 : hash.indexOf('?') - 2);
}

function filterEmptyQuery($query) {
	var query = {};
	for(var i in $query) {
		$query[i] ? query[i] = $query[i] : null;
	}
	return query;
}
export {
	isGoRouter,
	getRouterPath,
	filterEmptyQuery
};


// WEBPACK FOOTER //
// ./src/common/utils/assist.js